import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { SkeletonButton, SkeletonBadge, SkeletonText, SkeletonTitle } from '@/components/ui/skeleton-base';
import { Skeleton } from '@/components/ui/skeleton';

export const StripeEditSkeleton = () => {
    return (
        <div className="container mx-auto py-8">
            {/* Header */}
            <div className="mb-6 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <Skeleton className="h-10 w-10" />
                    <SkeletonTitle className="w-64" />
                </div>
                <div className="flex gap-2">
                    <SkeletonButton />
                    <SkeletonButton />
                </div>
            </div>

            <div className="space-y-6">
                {/* General Settings Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-40" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div>
                            <SkeletonText className="mb-2 w-16" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                        <div className="flex items-center space-x-2">
                            <Skeleton className="h-5 w-5" />
                            <SkeletonText className="w-20" />
                        </div>
                    </CardContent>
                </Card>

                {/* Stripe Connection Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-36" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <SkeletonText className="mb-4 w-3/4" />
                        <div className="space-y-4">
                            <div className="flex items-center gap-2">
                                <SkeletonText className="w-24" />
                                <SkeletonBadge />
                            </div>
                            <Skeleton className="h-10 w-full" />
                        </div>
                    </CardContent>
                </Card>

                {/* Test Mode Settings Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-40" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="flex items-center space-x-2">
                            <Skeleton className="h-5 w-5" />
                            <SkeletonText className="w-32" />
                        </div>
                    </CardContent>
                </Card>

                {/* Notification Settings Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-44" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="flex items-center space-x-2">
                            <Skeleton className="h-5 w-5" />
                            <SkeletonText className="w-56" />
                        </div>
                    </CardContent>
                </Card>

                {/* Statement Descriptor Card */}
                <Card className="mb-6">
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-44" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="space-y-3 rounded-lg bg-muted p-4">
                            <div className="space-y-2">
                                <div>
                                    <SkeletonText className="mb-1 w-48" />
                                    <SkeletonText className="w-32" />
                                </div>
                                <div>
                                    <SkeletonText className="mb-1 w-52" />
                                    <SkeletonText className="w-24" />
                                </div>
                            </div>
                            <div className="space-y-2">
                                <SkeletonText className="w-64" />
                                <SkeletonText className="w-56" />
                                <div className="space-y-1 pl-4">
                                    <SkeletonText className="w-60" />
                                    <SkeletonText className="w-52" />
                                    <SkeletonText className="w-48" />
                                </div>
                            </div>
                        </div>

                        <div>
                            <SkeletonText className="mb-2 w-52" />
                            <Skeleton className="h-10 w-full" />
                            <div className="mt-2 space-y-2">
                                <SkeletonText className="w-full" />
                                <SkeletonText className="w-3/4" />
                                <div className="rounded-lg border border-blue-200 bg-blue-50 p-3">
                                    <SkeletonText className="w-2/3" />
                                    <SkeletonText className="mt-1 w-1/2" />
                                </div>
                            </div>
                        </div>
                    </CardContent>
                </Card>

                {/* Features Card */}
                <Card>
                    <CardHeader>
                        <CardTitle>
                            <SkeletonText className="w-36" />
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-2 pl-4">
                            <SkeletonText className="w-44" />
                            <SkeletonText className="w-36" />
                            <SkeletonText className="w-48" />
                            <div className="pl-4 space-y-1">
                                <SkeletonText className="w-40" />
                                <SkeletonText className="w-52" />
                                <SkeletonText className="w-44" />
                            </div>
                            <SkeletonText className="w-52" />
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

